import React from "react";
import styles from "./avatar.module.scss";

function stringToBrightColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 55%)`;
}
function Avatar({ name, dpUrl, size = 50, fontSize=12}) {

  const initials = name
    ? name.split(" ").map(n => n[0]).join("").toUpperCase()
    : "?";
  const bgColor = stringToBrightColor(name);
  return dpUrl ? (
    <img
      src={dpUrl}
      alt={name || "Profile"}
      className={styles.avatar}
      style={{ width: size, height: size }}
    />
  ) : (
    <div
      className={styles.avatar}
      style={{ width: size, height: size, fontSize: fontSize, backgroundColor: bgColor }}
    >
      {initials}
    </div>
  );
}

export default Avatar;
